import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, Redirect, withRouter } from "react-router-dom";
import Logo from "../assets/images/logo_marketplace.png";
import appConfig from "../config/appConfig";
import UserService from "../services/UserService";
import { updateEmail, updatePassword, onLoggedin } from "../actions";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isLoad: false,
      });
    }, 500);
    document.body.classList.remove("theme-cyan");
    document.body.classList.remove("theme-purple");
    document.body.classList.remove("theme-blue");
    document.body.classList.remove("theme-green");
    document.body.classList.remove("theme-orange");
    document.body.classList.remove("theme-blush");

    const activeRole = this.getRoleFromLocation(this.props.location.search);
    const params = new URLSearchParams(this.props.location.search);
    const hasPortalError = params.get("error") === "portal-mismatch";

    if (
      appConfig.auth.enableKeycloak &&
      activeRole === "admin" &&
      !hasPortalError &&
      !UserService.isLoggedIn()
    ) {
      UserService.startPortalLogin("admin");
    }
  }

  getRoleFromLocation = (search = "") => {
    const pathname = this.props.location.pathname || "";
    const params = new URLSearchParams(search);

    if (pathname.endsWith("/admin/login")) {
      return "admin";
    }

    return params.get("role") === "vendor" ? "vendor" : "customer";
  };

  getRoleContent = () => {
    const activeRole = this.getRoleFromLocation(this.props.location.search);

    if (activeRole === "admin") {
      return {
        eyebrow: "Area amministrazione",
        title: "Accedi all'area amministrativa Marketplace",
        description:
          "Gestisci utenti, approvazioni e attivita riservate da un accesso dedicato e separato dai portali pubblici.",
        highlights: [
          "Accesso riservato",
          "Operazioni amministrative",
          "Controllo centralizzato",
        ],
        primaryLabel: "Accedi come amministratore",
        secondary: (
          <span>
            Accesso riservato agli amministratori Marketplace. <Link to={`${process.env.PUBLIC_URL}/dashboard`}>Torna alla home</Link>
          </span>
        ),
      };
    }

    if (activeRole === "vendor") {
      return {
        eyebrow: "Area venditori",
        title: "Accedi al pannello venditori Marketplace",
        description:
          "Gestisci richieste, offerte e operativita del tuo punto vendita in un'unica area riservata.",
        highlights: [
          "Richieste in tempo reale",
          "Offerte rapide",
          "Workflow centralizzato",
        ],
        primaryLabel: "Accedi come venditore",
        secondary: (
          <span>
            Non hai ancora un account?{" "}
            <a
              href={`${process.env.PUBLIC_URL}/seller-registration`}
              style={{ color: "#0d5ba4", fontWeight: 600 }}
              >
              Registrati
            </a>
          </span>
        ),
      };
    }

    return {
      eyebrow: "Area clienti",
      title: "Accedi alla tua area cliente Marketplace",
      description:
        "Rivedi le richieste inviate, monitora le offerte ricevute e continua il tuo percorso nel marketplace.",
      highlights: [
        "Richieste sempre disponibili",
        "Offerte ricevute in evidenza",
        "Storico personale centralizzato",
      ],
      primaryLabel: "Accedi come cliente",
      secondary: (
        <>
        <span>
          Hai già un account?{" "}
          <a
            href={`${process.env.PUBLIC_URL}/registration`}
            style={{ color: "#0d5ba4", fontWeight: 600 }}
          >
            Registrati
          </a>
        </span>
        <br />
        <span>
          Vuoi iniziare subito dal marketplace?{" "}
          <a
            href={`${process.env.PUBLIC_URL}/dashboard`}
            style={{ color: "#0d5ba4", fontWeight: 600 }}
          >
            Torna alla home
          </a>
        </span>
        </>
      ),
    };
  };

  getPortalErrorMessage = () => {
    const params = new URLSearchParams(this.props.location.search);
    const error = params.get("error");
    const expectedPortal = this.getRoleFromLocation(this.props.location.search);

    if (error !== "portal-mismatch") {
      return "";
    }

    if (expectedPortal === "admin") {
      return "Questo account non puo accedere all'area amministrativa.";
    }

    if (expectedPortal === "vendor") {
      return "Questo account non puo accedere all'area venditori.";
    }

    return "Questo account non puo accedere all'area clienti.";
  };

  renderPrimaryAction = (label) => {
    const activeRole = this.getRoleFromLocation(this.props.location.search);
    const buttonStyle = {
      color: "#ffffff",
      minWidth: 280,
      padding: "15px 32px",
      minHeight: 56,
      border: "0",
      borderRadius: 16,
      background: "linear-gradient(135deg, #0d5ba4 0%, #1fa2ff 100%)",
      boxShadow: "0 18px 34px rgba(13, 91, 164, 0.22)",
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 1.1,
      textAlign: "center",
    };

    if (appConfig.auth.enableKeycloak) {
      return (
        <button
          type="button"
          className="btn btn-primary btn-lg marketplace-login-primary"
          style={buttonStyle}
          onClick={() => UserService.startPortalLogin(activeRole)}
        >
          {label}
        </button>
      );
    }

    return (
      <a
        className="btn btn-primary btn-lg marketplace-login-primary"
        href="dashboard"
        style={buttonStyle}
      >
        Accedi
      </a>
    );
  };

  render() {
    if (appConfig.auth.enableKeycloak && UserService.isLoggedIn()) {
      const activeRole = this.getRoleFromLocation(this.props.location.search);
      if (activeRole === "admin" && UserService.isAdmin()) {
        return <Redirect to={`${process.env.PUBLIC_URL}/admin/venditori`} />;
      }

      if (activeRole === "vendor" && UserService.isSeller()) {
        return <Redirect to={`${process.env.PUBLIC_URL}/seller-richieste`} />;
      }

      return <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />;
    }

    const roleContent = this.getRoleContent();
    const portalErrorMessage = this.getPortalErrorMessage();
    const pageStyle = {
      minHeight: "100vh",
      background:
        "linear-gradient(90deg, #eff7ff 0%, #f5faff 40%, #ffffff 40%, #f8fbff 100%)",
    };
    const authMainStyle = {
      textAlign: "left",
    };
    const shellStyle = {
      width: "100%",
      maxWidth: 660,
      display: "flex",
      justifyContent: "flex-start",
      textAlign: "left",
    };
    const heroStyle = {
      background: "transparent",
      color: "#16324f",
      boxShadow: "none",
      border: "0",
      minHeight: 520,
      padding: "32px 32px 32px 8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      textAlign: "left",
      width: "100%",
    };
    const brandStyle = {
      marginBottom: 26,
      width: "100%",
      textAlign: "left",
    };
    const badgeStyle = {
      display: "inline-flex",
      alignSelf: "flex-start",
      marginBottom: 16,
      padding: "8px 14px",
      borderRadius: 999,
      background: "rgba(13, 91, 164, 0.10)",
      color: "#0d5ba4",
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
    };
    const titleStyle = {
      marginBottom: 16,
      color: "#16324f",
      fontSize: "clamp(2rem, 4vw, 3rem)",
      lineHeight: 1.06,
      fontWeight: 700,
      maxWidth: 540,
      textAlign: "left",
      overflowWrap: "anywhere",
      wordBreak: "break-word",
    };
    const descriptionStyle = {
      maxWidth: 500,
      marginBottom: 28,
      color: "#4e667d",
      fontSize: 17,
      lineHeight: 1.8,
      textAlign: "left",
      overflowWrap: "anywhere",
      wordBreak: "break-word",
    };
    const highlightsWrapStyle = {
      display: "flex",
      flexWrap: "wrap",
      gap: 18,
      justifyContent: "flex-start",
      width: "100%",
    };
    const highlightStyle = {
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      color: "#16324f",
      fontWeight: 600,
      lineHeight: 1.6,
      textAlign: "left",
    };
    const actionWrapStyle = {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 16,
      marginTop: 32,
      textAlign: "left",
    };

    return (
      <div className="theme-blue marketplace-login-page" style={pageStyle}>
        <div
          className="page-loader-wrapper"
          style={{ display: this.state.isLoad ? "block" : "none" }}
        >
          <div className="loader">
            <div className="m-t-30">
              <img
                src={require("../assets/images/logo_marketplace.png")}
                width="48"
                height="48"
                alt="Marketplace"
              />
            </div>
            <p>Please wait...</p>
          </div>
        </div>
        <div className="hide-border marketplace-login-shell">
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main marketplace-auth-main" style={authMainStyle}>
              <div className="auth-box marketplace-login-box" style={shellStyle}>
                <div className="marketplace-login-card__hero" style={heroStyle}>
                  <div className="marketplace-login-card__brand" style={brandStyle}>
                    <img
                      src={Logo}
                      alt="Marketplace"
                      className="marketplace-login-card__logo"
                      style={{ filter: "none", maxWidth: 460 }}
                    />
                  </div>
                  <span style={badgeStyle}>{roleContent.eyebrow}</span>
                  <h1 style={titleStyle}>{roleContent.title}</h1>
                  <p style={descriptionStyle}>{roleContent.description}</p>
                  {portalErrorMessage ? (
                    <div
                      style={{
                        width: "100%",
                        maxWidth: 500,
                        marginBottom: 24,
                        padding: "14px 18px",
                        borderRadius: 14,
                        background: "rgba(215, 58, 73, 0.08)",
                        border: "1px solid rgba(215, 58, 73, 0.18)",
                        color: "#b42318",
                        fontWeight: 600,
                        lineHeight: 1.5,
                      }}
                    >
                      <i className="fa fa-ban" style={{ marginRight: 10 }}></i>
                      {portalErrorMessage}
                    </div>
                  ) : null}
                  <div className="marketplace-login-card__highlights" style={highlightsWrapStyle}>
                    {roleContent.highlights.map((highlight) => (
                      <span key={highlight} style={highlightStyle}>
                        <i className="fa fa-check-circle" style={{ color: "#1fa2ff" }}></i>
                        {highlight}
                      </span>
                    ))}
                  </div>
                  <div style={actionWrapStyle}>
                    {this.renderPrimaryAction(roleContent.primaryLabel)}
                    <span className="helper-text" style={{ color: "#6f889f" }}>
                      <i className="fa fa-lock"></i>{" "}
                      <a
                        href={`${process.env.PUBLIC_URL}/forgotpassword`}
                        style={{ color: "#0d5ba4", fontWeight: 600 }}
                      >
                        Password dimenticata?
                      </a>
                    </span>
                    <div style={{ color: "#16324f" }}>{roleContent.secondary}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  updateEmail: PropTypes.func.isRequired,
  updatePassword: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
};

const mapStateToProps = ({ loginReducer }) => ({
  email: loginReducer.email,
  password: loginReducer.password,
});

export default withRouter(
  connect(mapStateToProps, {
    updateEmail,
    updatePassword,
    onLoggedin,
  })(Login)
);






